// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e98a63f2","239":"d81497f7","453":"2176b4f1","501":"ef61999e","732":"7b8b850d"}[chunkId] + ".chunk.js";
};